export default __webpack_public_path__ + "static/visu@2x-8cbdbc8c10b21792049be9996ea7938f.jpg";